import {
  Button,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  Typography
} from '@material-ui/core'
import { useState } from 'react'
import { produtosRodopar } from '../services'

type Props = {
  isOpen: boolean
  handleClose: () => void
}

export function SincronizarDialog({ isOpen, handleClose }: Props) {
  const [isSubmitting, setIsSubmitting] = useState(false)

  async function handleSubmit() {
    try {
      setIsSubmitting(true)

      await produtosRodopar()

      handleClose()
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <Dialog
      open={isOpen}
      onClose={handleClose}
      aria-labelledby="form-dialog-title"
      aria-describedby="form-dialog-description"
      fullWidth
      maxWidth="sm"
    >
      <DialogTitle>Sincronizar Produtos - Rodopar</DialogTitle>

      <DialogContent>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Typography variant="body1">
              Deseja sincronizar os produtos com a Rodopar?
            </Typography>
          </Grid>

          <Grid item xs={12} container justifyContent="flex-end" spacing={2}>
            <Grid item style={{ width: 160 }}>
              <Button
                fullWidth
                variant="outlined"
                onClick={handleClose}
                disabled={isSubmitting}
              >
                Cancelar
              </Button>
            </Grid>

            <Grid item style={{ width: 200 }}>
              <Button
                fullWidth
                variant="contained"
                color="primary"
                onClick={handleSubmit}
                disabled={isSubmitting}
              >
                {isSubmitting ? (
                  <CircularProgress color="inherit" size={24} />
                ) : (
                  'Sincronizar'
                )}
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  )
}
